import { render, staticRenderFns } from "./fl.vue?vue&type=template&id=ca10066a&scoped=true&"
import script from "./fl.vue?vue&type=script&lang=js&"
export * from "./fl.vue?vue&type=script&lang=js&"
import style0 from "./fl.vue?vue&type=style&index=0&id=ca10066a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca10066a",
  null
  
)

export default component.exports